import { createReducer, on } from '@ngrx/store';
import { HolidayActions } from './holiday.actions';
import { Holiday } from '@core/interface/holiday';
import { Pagination } from '@core/interface/core';

export const HolidayFeatureKey = 'holiday';

export interface HolidayState {
  holidays: Holiday[];
  isLoading: boolean;
  isDeleted: boolean;
  loadError?: any;
  deleteError?: any;
  addEditError?: any;
  pagination: Pagination;
}

export const initialState: HolidayState = {
  holidays: [],
  isLoading: true,
  isDeleted: false,
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 100,
  },
};

export const HolidayReducer = createReducer(
  initialState,
  on(HolidayActions.loadHolidays, (state) => ({ ...state })),
  on(HolidayActions.loadHolidaysSuccess, (state, { data, pagination }) => ({
    ...state,
    pagination,
    holidays: data,
    isLoading: false,
    isDeleted: false,
    loadError: null,
  })),
  on(HolidayActions.loadHolidaysFailure, (state, { error }) => {
    return { ...state, loadError: error, isLoading: false, isDeleted: false };
  }),
  on(HolidayActions.addHolidaySuccess, (state, { data }) => ({
    ...state,
    holidays: [...state.holidays, data],
    isDeleted: false,
    addEditError: null,
  })),
  on(HolidayActions.addHolidayFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    addEditError: error,
  })),
  on(HolidayActions.updateHolidaySuccess, (state, { data }) => ({
    ...state,
    holidays: state.holidays.map((Holiday) =>
      data.id == Holiday.id ? data : Holiday
    ),
    isDeleted: false,
    addEditError: null,
  })),
  on(HolidayActions.updateHolidayFailure, (state, { error }) => ({
    ...state,
    isDeleted: false,
    addEditError: error,
  })),
  on(HolidayActions.deleteHolidaySuccess, (state, { success, id }) => ({
    ...state,
    isDeleted: success,
    deleteError: null,
    holidays: state.holidays.filter((Holiday) => Holiday.id !== id),
  })),
  on(HolidayActions.deleteHolidayFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    deleteError: error,
  })),
  on(HolidayActions.deleteHoliday, (state, error) => ({
    ...state,
    isDeleted: false,
    deleteError: null,
  })),
  on(HolidayActions.resetDeletedStatus, (state) => ({
    ...state,
    isDeleted: false,
  }))
);
